<template>
    <div class="search-people">
        <div class="search-users__list card">
            <div class="search-users__item" v-for="(user, index) in userArray" :key="user.userId">
                <div class="user-preview">
                    <router-link :to="{ name: 'UserProfile', params: { link: user.userContactInfo.link } }" class="user-preview__link" target="_blank">
                        <el-avatar class="user-preview__avatar" :size="50">
                            <user-avatar :userId="user.userContactInfo.userId" :alt="user.userContactInfo.firstName + ' ' + user.userContactInfo.lastName"/>
                        </el-avatar>

                        <div class="user-preview__info">
                            <div class="user-preview__name">
                                {{user.userContactInfo.firstName}}  {{user.userContactInfo.lastName}} 
                            </div>

                            <div class="user-preview__description">
                                {{ user.userContactInfo.city }},{{ user.userContactInfo.country }}
                            </div>
                        </div>
                    </router-link>
                </div>

                <el-divider v-if="index < userArray.length - 1" />

            </div>
            <div class="search-users__empty-text" v-if="userArray.length === 0">
                You have no {{type}} {{ type=='active' ? 'connections' : 'requests' }} yet
            </div>
        </div>

        <el-pagination
        v-if="userArray && userArray.length > 0"
        layout="prev, pager, next"
        :total="total"
        hide-on-single-page
        :page-size="limit"
        :current-page="currentPage"
        @current-change="onNavigate"
        />
    </div>
</template>
<script>
import UserAvatar from '../profile/UserAvatar.vue';
import { getConnections } from '@/api/profile.js';

export default {
    name: 'Connections',
    components: {
        UserAvatar,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        skip() {
            const { currentPage, limit } = this;
            return (currentPage - 1) * limit;
        },
    },

    data() {
        return {
            limit: 30,
            currentPage: 1,
            total: null,
            userArray: [],
        };
    },

    mounted() {
        this.handleReset();
        const {type, skip, limit} = this;
        this.fetchConnections( type, skip, limit);
    },
    
    methods: {
        handleRecieveData(data) {
            this.userArray = data.items;
            this.total = data.totalCount;
        },
        onNavigate(nextPage) {
            console.log(nextPage);
            this.currentPage = nextPage;
        },
        handleReset() {
            this.userArray = [];
            this.total = null;
        },
        async fetchConnections( type, skip, limit) {
            const { data, success } = await getConnections( type, skip, limit);
            if (success) {
                this.handleRecieveData(data);
            }
        },
    },
}

</script>

<style lang="scss">
.search-users {
    &__heading {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
    }

    &__title {
        margin: 0;
        margin-bottom: var(--global-dimension-size-250);
        font-weight: 500;
        font-size: var(--font-size-800);
    }

    &__list {}

    &__item {}

    &__empty-text {}
}

.user-preview {
    $this: &;

    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    &__link {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;

        &:hover {
            #{$this}__name {
                color: var(--color-primary-400);
            }
        }
    }

    &__avatar {
        margin-right: var(--global-dimension-size-125);
    }

    &__info {}

    &__name {
        font-weight: var(--global-font-weight-medium);
    }

    &__role {
        margin-left: var(--global-dimension-size-125);
    }

    &__description {
        margin-bottom: var(--global-dimension-size-65);
        font-size: var(--font-size-200);
    }

    &__participants-icon {
        margin-right: var(--global-dimension-size-65);
    }

    &__participants {
        font-size: var(--font-size-200);
    }
}</style>
